<template>
  <div class="full-height">
    <JtDocsViewer
      :src="fileSrc"
      :title="reportTitle"
      pdf
      ref="reportModal"
      v-on:hide="() => {showReport = false}"
    />
    <crud-layout-search
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :params="params"
    >

      <page
        slot="page"
        slot-scope="{ params, forms, showMessage, actionButton }"
        :params="params"
        :forms="forms"
        @action-button="actionButton"
        @show-message="showMessage"
      >

        <template slot="form" slot-scope="{ form, actionClick }">
          <crud-form
            ref="crudForm"
            :form="form"
            :model="form.dadosForm"
            @action-click="actionClick"
          >
            <div class="row">
              <person-search
                class="col-12 q-px-sm"
                ref="personSearch"
                v-if="physicalPerson(form)"
                v-model="form.dadosForm.physicalPerson"
                name="physicalPerson"
                :float-label="physicalPerson(form).label"
                :required="true"
                :input="physicalPerson(form)"
                @found="(data) => $emit('search-found', data)"
              />
              <crud-input class="col-6 q-px-sm" nmInput="nmLogin" />
              <crud-input class="col-6 q-px-sm" nmInput="assignConsentLetter" ref="assignConsentLetter"/>
              <crud-input class="col-6 q-px-sm" nmInput="departmentConsentLetterType" />
              <crud-input class="col-6 q-px-sm" nmInput="tabSituacaoUsuario" />
              <crud-input class="col-12 q-px-sm" nmInput="dsEmailUsuario" />
              <crud-input
                class="col-12 q-px-sm"
                nmInput="segPerfilAcessoUsuarios"
              />
              <crud-input
                class="col-12 q-px-sm"
                nmInput="userWasteDepartments"
              />

              <crud-compositions
                class="col-12 q-px-sm"
                :form="form"
                :model="form.dadosForm"
                @action-click="actionClick"
              >
                <crud-composition
                  ref="modalForm"
                  slot="userWasteOrganizationalStructures"
                  slot-scope="dados"
                  v-bind="dados"
                >
                  <crud-form
                    slot="modal-form"
                    slot-scope="dadosModal"
                    v-bind="dadosModal.form"
                    :form="dadosModal.form"
                    :model="dadosModal.form.dadosForm"
                    @action-click="dadosModal.actionClick"
                    class="formContainer"
                  >
                    <div class="full-width full-height">
                      <q-scroll-area id="scroll-area">
                        <div class="row q-col-gutter-x-lg q-col-gutter-y-xs">
                          <organizational-structure-search
                            v-model="
                              dadosModal.form.dadosForm.organizationalStructure
                            "
                          />
                        </div>
                      </q-scroll-area>

                      <div
                        class="row full-width justify-center q-gutter-md"
                        v-if="dadosModal && !!dadosModal.form.buttons.length"
                      >
                        <div
                          v-for="(button, index) in dadosModal.form.buttons"
                          :key="index"
                          class="buttons-bar"
                        >
                          <div class="full-width row">
                            <q-btn
                              class="q-px-xl"
                              :color="
                                button.type.toUpperCase() == 'SUBMIT'
                                  ? 'info'
                                  : 'grey-7'
                              "
                              @click="
                                () => {
                                  dadosModal.formButtonClick({
                                    button,
                                    fields: dadosModal.form.dadosForm,
                                  });
                                }
                              "
                              >{{ button.label }}</q-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </crud-form>
                </crud-composition>
              </crud-compositions>
            </div>
          </crud-form>
        </template>
      </page>
    </crud-layout-search>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { QScrollArea } from 'quasar'
import { JtCrud, JtCompositionFormModal, JtDocs } from 'jtech-webcomps'
import PersonSearch from '../../components/input/person-search/PersonSearch.vue'
import OrganizationalStructureSearch from '../../components/input/organizational-structure-search/OrganizationalStructureSearch.vue'
import { repository } from 'src/jtech/jtech-repository'

const { JtDocsViewer } = JtDocs

const { CrudLayoutSearch, page, form, input, compositions, composition } =
  JtCrud

@Component({
  name: 'User',
  mixins: [CrudLayoutSearch],
  components: {
    CrudLayoutSearch,
    page,
    'crud-form': form,
    'crud-input': input,
    'crud-compositions': compositions,
    'crud-composition': composition,
    PersonSearch,
    OrganizationalStructureSearch,
    JtCompositionFormModal,
    QScrollArea,
    repository,
    JtDocsViewer
  }
})
class User extends Vue {
  showReport = false;
  reportTitle = null;
  fileSrc = null;

  get nmInterface () {
    return this.interface
  }

  physicalPerson (form) {
    if (!form.physicalPerson) {
      form.physicalPerson = form?.inputs?.find(
        (input) => input.model == 'physicalPerson'
      )
    }
    const departmentConsentLetterTypeField = form.inputs.find(
      (i) => i.name == 'departmentConsentLetterType'
    )
    if (departmentConsentLetterTypeField) {
      departmentConsentLetterTypeField.readonly = form.dadosForm.assignConsentLetter === 'N'
    }
    return form.physicalPerson
  }

  async actionButtonReport ({ button, params }) {
    const { nmArquivo } = await this.$jt.repository.resolveLogic(
      'userWasteReport.userWasteReport',
      {
        userWaste: params.id,
        cdRelatorio: 'Relatório de Usuário',
        relFormaGeracao: 1,
        relFormatoRelatorio: 1
      }
    )
    const format = 'pdf'
    const result = await repository.downloadFile(
      nmArquivo,
      format,
      '',
      'application/' + format
    )
    this.fileSrc = URL.createObjectURL(result)
    this.reportTitle = button.label

    setTimeout(() => {
      this.$refs.reportModal.show()
    }, 100)
  }

  mounted () {
    try {
      this.$refs.crudLayout.onButton('btReport', this.actionButtonReport)
    } catch (error) {
      console.error(error)
    }
  }
}
export default User
</script>
<style lang="stylus" scoped>
#scroll-area {
  height: calc(68vh - 12px);
}

.buttons-bar {
  min-height: 50px;
}

.jt-form {
  margin-top: 0px;
}
</style>
